<template>
  <div class="tw-mt-8 tw-mb-24 lg:tw-pb-12">
    <div class="lg:tw-w-1/2 tw-mx-12 lg:tw-mx-auto">
      <div class="tw-h-2 tw-w-full tw-bg-gray-300 tw-relative">
        <div class="tw-h-2 tw-bg-orange-medium tw-absolute tw-transition-all" :style="{width: progressWidth}"></div>
      
        <div class="tw-flex tw-justify-between tw-absolute tw-w-full tw--translate-y-1/2 tw-top-1/2" style="right: -2px;">
          <ProgressBarStep 
            v-for="s in [1,2,3,4]"
            :key="'stepProg-'+s"
            :step="s.toString()" 
            :active="props.step != undefined && props.step >= s" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ProgressBarStep from './_ProgressBarStep.vue' 

const props = defineProps({
  step: Number,
})

const progressWidth = computed(() => {
  if (props.step != undefined) {
    return ((((props.step - 1) / 3)*100).toString() + "%");
  } else {
    return '0%';
  }
})

</script>